class RvCartCountdown extends HTMLElement {
  connectedCallback() {
    clearInterval(this.timer);
    this.end = Date.parse(this.dataset.end);
    this.units = ['days','hours','minutes','seconds'].map(unit => this.querySelector('[data-unit="'+unit+'"]'));
    this.tick();
    if (!this.hidden) this.timer = setInterval(() => this.tick(), 1000);
  }
  tick() {
    const remaining = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
    if (!Number.isFinite(remaining) || remaining <= 0) {
      this.hidden = true;
      clearInterval(this.timer);
      return;
    }
    const values = [Math.floor(remaining/86400),Math.floor(remaining/3600)%24,Math.floor(remaining/60)%60,remaining%60];
    this.units.forEach((node,index) => {
      const value = String(values[index]).padStart(2,'0');
      if (node && node.textContent !== value) node.textContent = value;
    });
    this.hidden = false;
  }
  disconnectedCallback() { clearInterval(this.timer); }
}
if (!customElements.get('rv-cart-countdown')) customElements.define('rv-cart-countdown',RvCartCountdown);
